<div class="booking-edit">

  <button matButton class="simple-button-rent" mat-button (click)="showBookingCalendar = !showBookingCalendar;" cdkOverlayOrigin #trigger1="cdkOverlayOrigin">
    Dates reservées<mat-icon>date_range</mat-icon>
  </button>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger1"
    [cdkConnectedOverlayOpen]="showBookingCalendar">

    <div class="overlay-box">
      @for (booking of currentBookings ; track booking; let i = $index) {
        <h6>
          Start Date: {{ dateFormat(booking.startDate) }} - End Date: {{ dateFormat(booking.endDate) }} - Statut: {{booking.status}}
        </h6>
      }
      <mat-calendar [dateFilter]="filterBookedDates" >
      </mat-calendar>
      <button matButton class="simple-button-rent"  mat-button (click)="showBookingCalendar = !showBookingCalendar; " ><b> Fermer </b><mat-icon>close</mat-icon></button>

    </div>
  </ng-template>

  <!--
  <mat-form-field *ngIf="showRentalDates">
    <mat-label>Dates Indisponibles</mat-label>
    <input required matInput [matDatepicker]="picker" name ="appointmentDate" >
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field> -->

  <!-- <mat-calendar *ngIf="showRentalDates" (selectedChange)="onSelectedDateRangeChange($event)" [selected]="selectedDateRange">
</mat-calendar> -->

<button matButton class="simple-button-rent" mat-button
  (click)="showBookingAddNew = !showBookingAddNew;"
  cdkOverlayOrigin #trigger="cdkOverlayOrigin">Réserver dates<mat-icon>add_calendar</mat-icon>
</button>
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="showBookingAddNew">

  <div class="overlay-box">

    <mat-calendar
      [dateFilter]="filterPastDatesAndBookedDates"
      [selected]="selectedDateRange"
      (selectedChange)="onSelectedDateRangeChange($event!)"
      [dateClass]="dateClass">
    </mat-calendar>
    <button matButton class="simple-button-rent"  mat-button (click)="showBookingAddNew = !showBookingAddNew; " ><b> Fermer </b><mat-icon>close</mat-icon></button>
    <button matButton class="simple-button-rent"  mat-button (click)="addNewBooking();"><b> Reserver </b><mat-icon>save</mat-icon></button>

  </div>
</ng-template>
<!--
<button matButton class="simple-button"  mat-button (click)="showRentalDates = !showRentalDates;"><b> {{ showRentalDates? 'Annuler': 'Ajouter' }} </b><mat-icon> {{ showRentalDates? 'close': 'add' }}</mat-icon></button>
-->
</div>
